import React, { useState, useCallback } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { formatVars } from "../helpers/translation"
import { TxlActionButton } from "./TxlButton"
import DownloadHelpDialog from "./DownloadHelpDialog"
import { requestDownload } from "../state/modules/download"

const DownloadButton = ({ transfer, downloadTransfer }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  const [showModal, setShowModal] = useState(false)

  const isAvailable = transfer?.status?.isAvailable
  const isEncrypted = transfer?.status?.isEncrypted
  const fileCount = transfer?.getSelectedFileCount?.call(transfer) || 0

  const onDownload = useCallback(() => {
    if (isAvailable) {
      if (isEncrypted) {
        setShowModal(true)
      } else {
        downloadTransfer(transfer)
      }
    }
  }, [isAvailable, isEncrypted, setShowModal, downloadTransfer, transfer])

  return (
    <div>
      <TxlActionButton disabled={!isAvailable} onClick={onDownload}>
        <i className="icon-download" />
        <span>
          {formatVars(language, t("##.Download.Download"), {
            NUM: fileCount,
          })}
        </span>
      </TxlActionButton>
      <DownloadHelpDialog
        fileCount={fileCount}
        isOpen={showModal}
        dismiss={() => setShowModal(false)}
        accept={() => {
          downloadTransfer(transfer)
          setShowModal(false)
        }}
      />
    </div>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    downloadTransfer: transfer => dispatch(requestDownload(transfer)),
  }
}

export default connect(null, mapDispatchToProps)(DownloadButton)
